import { lazy } from "react"
import {
  APIARIES_LIST_VIEW,
  APIARY_VIEW,
  EDIT_APIARY_VIEW,
  NEW_APIARY_VIEW,
} from "@/features/bees/routes/route-list.ts"
import BottomMenuLayout from "@/layouts/bottom-menu-layout/bottom-menu-layout"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout"

const AllApiariesTab = lazy(
  () =>
    import(
      "@/features/bees/views/apiaries/all-apiaries-tab/all-apiaries-tab.tsx"
    ),
)
const ApiaryView = lazy(
  () => import("@/features/bees/views/apiaries/apiary-view/apiary-view.tsx"),
)
const EditApiaryView = lazy(
  () =>
    import(
      "@/features/bees/views/apiaries/edit-apiary-view/edit-apiary-view.tsx"
    ),
)
const NewApiaryView = lazy(
  () =>
    import(
      "@/features/bees/views/apiaries/new-apiary-view/new-apiary-view.tsx"
    ),
)

const noMenuLayoutApiariesRoutes = [
  {
    path: APIARY_VIEW,
    element: <ApiaryView />,
  },
  {
    path: NEW_APIARY_VIEW,
    element: <NewApiaryView />,
  },
  {
    path: EDIT_APIARY_VIEW,
    element: <EditApiaryView />,
  },
]

const bottomMenuLayoutApiariesRoutes = [
  {
    path: APIARIES_LIST_VIEW,
    element: <AllApiariesTab />,
  },
]

const MOBILE_APIARIES_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: noMenuLayoutApiariesRoutes,
  },
  {
    element: <BottomMenuLayout />,
    children: bottomMenuLayoutApiariesRoutes,
  },
]

const DESKTOP_APIARIES_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: [
      ...noMenuLayoutApiariesRoutes,
      ...bottomMenuLayoutApiariesRoutes,
    ],
  },
]

export const getApiaryRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_APIARIES_ROUTES : MOBILE_APIARIES_ROUTES
}
